import { c as _c } from "react/compiler-runtime";
import { Popup, Position } from '../Popup';
import PopupArrow from '../Popup/PopupArrow';
import styles from './Tooltip.module.css';
import type { TooltipProps } from './types';
function Tooltip(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["hover", "focus"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Popup {...props} Anchor={PopupArrow} triggerEvents={t0} contentClassName={styles.tooltipContent} contentWrapperClassName={styles.opacityTransition} popupOpenWrapperClassName={styles.opacityTransitionOpen} preferredPopupPosition={Position.TOP} />;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export default Tooltip;